import React from 'react'
import Testimonials from 'pages/pga-coach/profile/new/form-components/testimonials'

const EditProfileTestimonials = props => (
  <Testimonials hideSubheader filledDeleteButton {...props} />
)

export default EditProfileTestimonials
